import { connect } from "react-redux";
import { Dispatch } from "redux";

import Header from "./header";
import { AppState } from '../../core/reducers/rootReducer';
import { getTransactionIdFromURL, isUserLoggedIn } from '../../constants/utils';
import { getProfileDetails } from "../../core/actionCreators/profileDetailsActionCreators";
import { ProfileActions } from "../../core/actionTypes/profileDetailsActionTypes";


const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    name: state.transactionDetails.userName,
    email: state.transactionDetails.emailId,
    isAuthenticated: isUserLoggedIn(txnId),
    isLoading: state.isLoading,
    profileDetails: state.profileDetails,
    partnerData: state.auth,
    transactionDetails: state.transactionDetails,
  };
};


const mapDispatchToProps = (dispatch: Dispatch<ProfileActions>) => ({
  getProfileDetails: () => {
    dispatch(getProfileDetails());
  }
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
